import { createClient } from '@supabase/supabase-js'

export const supabaseUrl = 'https://nemmitznpthnrshbjipz.supabase.co'
export const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5lbW1pdHpucHRobnJzaGJqaXB6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEwNzg0MjIsImV4cCI6MjA3NjY1NDQyMn0.NCtVTP4zZJttp4a9BuxAoD1yo4Ik8r8gSxiiAnWrhwk'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})
